<template>
  <!-- 走进瑞谦 -->
  <div class="into-rq-container">
    <div class="carousel-wrapper">
      <Carousel3D :carouselItems="carouselItems" />
    </div>
    <WelfareIcons :welfareItems="intoIcon" />
    <div class="simple-swiper-section">
      <SwiperFourSlides
        :title="swiperData.title"
        :description="swiperData.description"
        :images="swiperData.images"
        :autoplayDelay="1000"
      />
    </div>
  </div>
</template>

<script>
  import Carousel3D from '../components/Carousel3D.vue'
  import WelfareIcons from '../components/WelfareIcons.vue'
  import SwiperFourSlides from '../components/SwiperFourSlides.vue'
  import { intoRQSwiperData, intoRQWelfareIcons, intoRQCarouselItems } from '@/data/aboutData'

  export default {
    name: 'IntoRQ',
    components: {
      Carousel3D,
      WelfareIcons,
      SwiperFourSlides
    },
    data() {
      return {
        swiperData: intoRQSwiperData,
        intoIcon: intoRQWelfareIcons,
        carouselItems: intoRQCarouselItems
      }
    },
    mounted () {},
    methods: {}
  }
</script>

<style scoped>
.into-rq-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  background: #fff;
}

.carousel-wrapper {
  width: 100%;
  background: #fff;
}

.simple-swiper-section {
  width: 100%;
  max-width: 1400px;
  margin: 40px auto;
  padding: 0 20px;
}
</style>
